(() => {
  if (window.lomaVistaMastodonLayoutLoaded) return;
  window.lomaVistaMastodonLayoutLoaded = true;

  function initialize() {
    document.querySelectorAll('[data-mastodon-newsletter]').forEach(form => {
      form.querySelector('button[type="submit"]').disabled = !form.dataset.listId.trim() || !form.dataset.companyId.trim();
    });
  }
  document.addEventListener('shopify:section:load', initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();

  // A deliberate email signup uses the existing account's public Client API.
  // It neither enables tracking nor changes the site's cookie-consent choices.
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-mastodon-newsletter]');
    if (!form) return;
    event.preventDefault();
    if (form.dataset.submitting === 'true' || !form.reportValidity()) return;
    const status = form.querySelector('[role="status"]');
    if (form.elements.website.value) return;
    const listId = form.dataset.listId.trim();
    const companyId = form.dataset.companyId.trim();
    if (!listId || !companyId) {
      status.textContent = 'Email signup is temporarily unavailable. Please try again later.';
      return;
    }
    const button = form.querySelector('button[type="submit"]');
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 15000);
    form.dataset.submitting = 'true';
    form.setAttribute('aria-busy', 'true');
    button.disabled = true;
    status.textContent = 'Submitting…';
    try {
      const response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(companyId)}`, {
        method: 'POST',
        credentials: 'omit',
        signal: controller.signal,
        headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-07-15' },
        body: JSON.stringify({ data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Mastodon raffle — Keep Close',
            profile: { data: { type: 'profile', attributes: {
              email: form.elements.email.value.trim(),
              subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
            } } }
          },
          relationships: { list: { data: { type: 'list', id: listId } } }
        } })
      });
      if (response.status !== 202) throw new Error('Subscription not accepted');
      status.textContent = 'Thanks! If you receive a confirmation email, follow its link to complete your signup.';
      form.reset();
    } catch {
      status.textContent = 'We could not confirm your signup. Please try again in a moment.';
    } finally {
      clearTimeout(timer);
      delete form.dataset.submitting;
      form.removeAttribute('aria-busy');
      button.disabled = false;
    }
  });
})();
